<button class="btn btn-next btn-block" type="button">{{ label }}</button>
